export const objectArrayToCsv = (data: Array<any>) => {
  const csvRows = [];
  const headers = Object.keys(data[0]);
  csvRows.push(headers.join(';'));

  for (const row of data) {
    const values = headers.map(header => {
      const escaped = row[header].toString().replace(/"/g, '\\"');
      return `"${escaped}"`;
    });
    csvRows.push(values.join(';'));
  }

  return csvRows.join('\n');
};

export const arrayToCsv = (data: Array<any>) => {
  const csvRow = [];
  csvRow.push(data.join(';'));

  return csvRow.join('\n');
};

export const download = (data: string, filename: string) => {
  const blob = new Blob([data], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.setAttribute('hidden', '');
  a.setAttribute('href', url);
  a.setAttribute('download', filename);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
